import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getItem } from "../utils/safeStorage";
import en from "./locale/en/translation.json";
import kz from "./locale/kz/translation.json";
import ru from "./locale/ru/translation.json";

const savedLanguage = getItem("i18nextLng");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedLanguage || "kk",
    fallbackLng: "kk",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: en,
      kk: kz,
      ru: ru,
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
